/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenu_viewer = {
    readonly isDeliveryOptionsDisabled: boolean | null;
    readonly isSbSharedRefineMenuDisplayPrefsSelectEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespAppliedFilters_viewer" | "SbSharedRefineMenuFilters_viewer">;
    readonly " $refType": "SbRespRefineMenu_viewer";
};
export type SbRespRefineMenu_viewer$data = SbRespRefineMenu_viewer;
export type SbRespRefineMenu_viewer$key = {
    readonly " $data"?: SbRespRefineMenu_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenu_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isDeliveryOptionsDisabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "DISABLE_SB_DELIVERY_OPTION_FILTERS"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"DISABLE_SB_DELIVERY_OPTION_FILTERS\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isSbSharedRefineMenuDisplayPrefsSelectEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespAppliedFilters_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '39f209dc12eb170b2cfa899dbe128ec4';
export default node;
